'use client';

import { useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Box, TableCell, TableRow, Typography } from '@mui/material';

import { ChampsIcon } from '~/shared';
import { SponsoredProductsResultsDetailedModelView } from '~/types';

export function ProductRow({
  product,
}: {
  product: SponsoredProductsResultsDetailedModelView[number];
}) {
  const [isShowingRowContent, setIsShowingRowContent] = useState(false);

  return (
    <>
      <TableRow
        key={product.sku}
        title={product.sku}
        sx={{
          cursor: 'pointer',
          '&:hover': {
            '.MuiTableCell-body': {
              backgroundColor: theme => theme.palette.grey[100],
            },
          },
          '.MuiTableCell-body': {
            backgroundColor: 'background.paper',
          },
          ...(product.daysLastWeekProducts?.length === 0
            ? { cursor: 'default' }
            : {}),
        }}
        onClick={() => {
          if (product.daysLastWeekProducts?.length > 0) {
            setIsShowingRowContent(!isShowingRowContent);
          }
        }}
      >
        <TableCell component="th" scope="row">
          <ExpandMore
            style={{
              ...(product.daysLastWeekProducts?.length === 0
                ? { opacity: 0 }
                : {}),
              ...(isShowingRowContent ? { transform: 'rotate(180deg)' } : {}),
              transition: 'transform 0.3s',
            }}
          />
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          sx={{
            position: 'sticky',
            left: 0,
            backgroundColor: 'background.paper',
          }}
        >
          <Box sx={{ display: 'flex', alignContent: 'center', gap: '10px' }}>
            <Typography
              sx={{ whiteSpace: 'nowrap' }}
              variant="body2"
              color="primary.main"
              fontWeight={500}
              component="p"
            >
              {product.name?.trim() || 'Produto Indisponível'}
            </Typography>
            {product.isBetterProduct && <ChampsIcon color="#FECA3D" />}
          </Box>
        </TableCell>
        <TableCell component="th" scope="row">
          <Typography
            sx={{ whiteSpace: 'nowrap' }}
            variant="body2"
            component="p"
          >
            {product.sku}
          </Typography>
        </TableCell>
        {/* <TableCell component="th" scope="row">
        <Typography sx={{ whiteSpace: 'nowrap' }} variant="body2" component="p">
          -
        </Typography>
      </TableCell> */}

        <TableCell component="th" scope="row">
          <Typography
            sx={{ whiteSpace: 'nowrap' }}
            variant="body2"
            component="p"
          >
            {product.impressions}
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row">
          <Typography
            sx={{ whiteSpace: 'nowrap' }}
            variant="body2"
            component="p"
          >
            {product.clicks}
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row">
          <Typography
            sx={{ whiteSpace: 'nowrap' }}
            variant="body2"
            component="p"
          >
            {product.ctr}%
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row">
          <Typography
            sx={{ whiteSpace: 'nowrap' }}
            variant="body2"
            component="p"
          >
            R$ {product.cpm}
          </Typography>
        </TableCell>
        <TableCell component="th" scope="row">
          <Typography
            sx={{ whiteSpace: 'nowrap' }}
            variant="body2"
            component="p"
          >
            R$ {product.cpc}
          </Typography>
        </TableCell>
      </TableRow>

      {product.daysLastWeekProducts.map(day => {
        return (
          <TableRow
            sx={{ ...(!isShowingRowContent ? { display: 'none' } : {}) }}
            key={day.dayWeek}
          >
            <TableCell component="th" scope="row" />
            <TableCell
              component="th"
              scope="row"
              sx={{
                position: 'sticky',
                left: 0,
                backgroundColor: 'background.paper',
              }}
            >
              <Typography
                sx={{ whiteSpace: 'nowrap' }}
                variant="body2"
                component="p"
              >
                {day.dayWeek}
              </Typography>
            </TableCell>
            <TableCell component="th" scope="row" />
            <TableCell component="th" scope="row">
              <Typography
                sx={{ whiteSpace: 'nowrap' }}
                variant="body2"
                component="p"
              >
                {day.impressions}
              </Typography>
            </TableCell>
            <TableCell component="th" scope="row">
              <Typography
                sx={{ whiteSpace: 'nowrap' }}
                variant="body2"
                component="p"
              >
                {day.clicks}
              </Typography>
            </TableCell>
            <TableCell component="th" scope="row">
              <Typography
                sx={{ whiteSpace: 'nowrap' }}
                variant="body2"
                component="p"
              >
                {day.ctr}%
              </Typography>
            </TableCell>
            <TableCell component="th" scope="row">
              <Typography
                sx={{ whiteSpace: 'nowrap' }}
                variant="body2"
                component="p"
              >
                R$ {day.cpm}
              </Typography>
            </TableCell>
            <TableCell component="th" scope="row">
              <Typography
                sx={{ whiteSpace: 'nowrap' }}
                variant="body2"
                component="p"
              >
                R$ {day.cpc}
              </Typography>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
